var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('img',{ref:"clippy",staticClass:"clippy",attrs:{"src":require('@/assets/img/clippy.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }